import { FC } from 'react';

import { Title, VSpacing } from '@hh.ru/magritte-ui';

import Nav from 'components/Admin/Nav/Nav';

export const AdminPageContentHeader: FC<{ title: string }> = ({ title }) => {
    return (
        <>
            <VSpacing default={24} />
            <Nav />
            <Title Element="h3" size="large">
                {title}
            </Title>
            <VSpacing default={24} />
        </>
    );
};
